import script from "./PbxDeviceRevealModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PbxDeviceRevealModal.vue?vue&type=script&setup=true&lang=js"

import "./PbxDeviceRevealModal.vue?vue&type=style&index=0&id=110db5e6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-110db5e6"]])

export default __exports__